export default class PopOut
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...PopOut.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$menu = this.DOM.$el.querySelector(this.options.selectorMenu)
        this.DOM.$scrollingParent = this.getScrollingParent()

        this.DOM.$el.addEventListener('click', this.onClick.bind(this), false)
        this.DOM.$menu.addEventListener('click', e => {
            if (e.target.classList.contains(this.options.selectorMenu.slice(1))) {
                e.stopPropagation()
            }
        }, false)
    }

    getScrollingParent() {
        const getStyleProp = (node, prop) => {
            return getComputedStyle(node, null).getPropertyValue(prop)
        }

        const isScrollable = (node) => {
            return /(auto|scroll)/.test(
                getStyleProp(node, 'overflow') +
                getStyleProp(node, 'overflow-y') +
                getStyleProp(node, 'overflow-x')
            )
        }

        const getScrollingParent = (node) => {
            return (!node || node === document.body) ? document.body : (isScrollable(node) ? node : getScrollingParent(node.parentElement))
        }

        return getScrollingParent(this.DOM.$el)
    }

    onClick(e) {
        const $$expandedPopouts = document.querySelectorAll(this.options.selector + `.${this.options.classNameIsExpanded}`)

        $$expandedPopouts.forEach($popout => {
            if ($popout !== this.DOM.$el) {
                $popout.classList.remove(this.options.classNameIsExpanded)
            }
        })

        this.DOM.$menu.classList.remove('is-bottom', 'is-top')
        this.DOM.$el.classList.toggle(this.options.classNameIsExpanded)
        this.setPosition()
        e.stopPropagation()

        document.body.addEventListener('click', () => {
            this.DOM.$el.classList.remove(this.options.classNameIsExpanded)
        }, {once: true})
    }

    setPosition() {
        const menuBottom = this.DOM.$menu.getBoundingClientRect().bottom
        let containerBottom

        if (this.DOM.$scrollingParent === document.body) {
            containerBottom = window.innerHeight + window.scrollY
        } else {
            containerBottom = this.DOM.$scrollingParent.getBoundingClientRect().bottom
        }

        const position = (menuBottom > containerBottom) ? 'top' : 'bottom'
        this.DOM.$menu.classList.add(`is-${position}`)
    }
}

PopOut.prototype.defaults = {
    classNameIsExpanded: 'is-expanded',
    menuOffset: 40,
    selector: '.js-popOut',
    selectorMenu: '.js-popOutMenu',
}
